/*
 *   File : confirm.js
 *   Author : https://evoqins.com
 *   Description : COnfirm modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { CustomTextArea, CustomTextInput } from '../FormElements';


const ConfirmModal = (props) => {

    const [note, setNote] = useState(false);
    const [noteError, setNoteError] = useState(false);

    const [ticketId, setTicketId] = useState("");
    const [ticketIdError, setTicketIdError] = useState("");

    useEffect(() => {
        setNoteError("");
    }, [note])

    useEffect(() => {
        setTicketIdError("");
    }, [ticketId])

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("confirm-modal-close");
        button.click();
        props.handleClose();
    };

    // handle confirm 
    const _handleConfirm = () => {

        let data = null;
        let is_valid = true;

        if (props.textInput) {
            if (ticketId.length === 0) {
                setTicketIdError("Please provide ticker number");

                is_valid = false
            }
            data = {
                fresh_desk_number: ticketId
            }
        }

        if (is_valid === true) {
            props.handleConfirm(data);
        }
        // _handleCloseModal();
    };

    // handle success 
    const _handleSuccess = () => {
        props.handleSuccess();
        _handleCloseModal();
        // navigate('/documents', { state: { refresh: true } });
    };

    return (
        <div className="modal fade"
            id="confirm-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="sendReportModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28 `}>
                <span id='confirm-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-3">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            {props.title}
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={props.status === true ? _handleSuccess : _handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-0 pb-1 padding-32px-lr'>
                        <p className='mb-0 e-text-dark-gray e-primary-font e-font-16 e-font-weight-400 line-height-20px'>
                            {props.description}
                        </p>

                        {props.textArea ?
                            <div className='pt-3'>
                                <CustomTextArea label="Reason"
                                    placeholder="Enter reason for rejection"
                                    type="text"
                                    value={note}
                                    error={noteError}
                                    required={true}
                                    className="w-100 "
                                    borderStyle="e-border-0-5px-arsenic"
                                    handleChange={(e) => setNote(e)} />
                            </div>
                            :
                            props.textInput && props.status === false ?
                                <div className='pt-3'>
                                    <CustomTextInput label={props.label}
                                        placeholder={`Enter ${props.label.toLowerCase()}`}
                                        type="number"
                                        required={true}
                                        value={ticketId}
                                        error={ticketIdError}
                                        className="w-100"
                                        // inputType={2}
                                        onKeyPress={_handleConfirm}
                                        handleChange={(e) => setTicketId(e)} />
                                </div>
                                :
                                null
                        }
                    </div>

                    {/* Modal footer */}
                    <div className='modal-footer border-0 pt-4 padding-32px-lr padding-32px-bottom gap-4'>
                        {props.status === false ?
                            <>
                                <SecondaryButton name="Cancel"
                                    paddingBlock="py-3 padding-54px-lr"
                                    onClick={_handleCloseModal} />
                                <PrimaryButton name={props.buttonText ? props.buttonText : "Confirm"}
                                    paddingBlock="padding-64px-lr py-3"
                                    className={props.loader ? "w-176px" : ""}
                                    loader={props.loader}
                                    onClick={_handleConfirm} />
                            </>
                            :
                            <SecondaryButton name="OK"
                                className="py-3 padding-66px-lr"
                                onClick={_handleSuccess} />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmModal;
